import {Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter} from '@angular/core';
import * as moment from 'moment';
import 'moment-timezone';
import {Subject} from 'rxjs';
import {Subscription} from 'rxjs/Subscription';

import {QuarterModel} from '../custom-quarter-model';

@Component({
    selector: 'custom-quarter-picker',
    templateUrl: './custom-quarter-picker.component.html',
    styleUrls: ['./custom-quarter-picker.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
})
export class CustomQuarterPickerComponent implements OnInit {
    @Input() date: QuarterModel;
    @Output() select = new EventEmitter<any>();
    public _model$ = new Subject<QuarterModel>();
    public _subscription: Subscription;
    public quarters: Array<number>;
    public years: Array<number>;
    private maxYear: number;
    private minYear: number;
    private curYear: number;
    private curQuarter: number;
    private _quarters = [
        {value: 1, name: 'Q1'},
        {value: 2, name: 'Q2'},
        {value: 3, name: 'Q3'},
        {value: 4, name: 'Q4'},
    ];
    public disabledPrev: boolean = false;
    public disabledNext: boolean = false;

    constructor() {
        this.years = this.generateSelectBoxYears();
        this.quarters = this.generateSelectBoxQuarters();

        this._subscription = this._model$.subscribe(date => {
            const newDate = date;
            const oldDate = {year: this.date.year, quarter: this.date.quarter};

            this.date = date;

            if (this.date && this.date.year && this.date.quarter) {
                if (this.date.quarter == 1 && this.date.year == this.minYear) {
                    this.disabledPrev = true;
                } else {
                    this.disabledPrev = false;
                }

                if (this.date.quarter == 4 && this.date.year == this.maxYear) {
                    this.disabledNext = true;
                } else {
                    this.disabledNext = false;
                }
            }

            if (oldDate.year != newDate.year || oldDate.quarter != newDate.quarter) {
                this.select.emit({
                    current: oldDate ? oldDate : null,
                    next: newDate,
                });
            }
        });
    }

    ngOnInit() {
        if (!this.date) {
            //Init date as well.
            this.date = {year: this.curYear, quarter: this.curQuarter};
        }
    }

    ngOnDestroy() {
        if (this._subscription) {
            this._subscription.unsubscribe();
        }
    }

    generateSelectBoxYears() {
        const cur_year = moment().year();
        const cur_month = moment().month();
        this.curYear = cur_year;
        this.curQuarter = Math.floor(cur_month / 3) + 1;
        const _years = [];

        this.minYear = Math.max(cur_year - 5, 2017);
        this.maxYear = cur_year;
        for (let i = this.minYear; i <= this.maxYear; i++) {
            _years.push(i);
        }

        return _years;
    }

    generateSelectBoxQuarters() {
        return [1, 2, 3, 4];
    }

    getQuarterName(i: number) {
        const quarterMap = new Map(this._quarters.map((i): [number, string] => [i.value, i.name]));
        return quarterMap.get(i);
    }

    navigatePrev() {
        if (this.date && this.date.year && this.date.quarter) {
            const newDate = {year: this.date.year, quarter: this.date.quarter};

            if (newDate.quarter == 1) {
                newDate.quarter = 4;
                newDate.year -= 1;
            } else {
                newDate.quarter -= 1;
            }

            this._model$.next(newDate);
        }
    }

    navigateNext() {
        if (this.date && this.date.year && this.date.quarter) {
            const newDate = {year: this.date.year, quarter: this.date.quarter};
            if (newDate.quarter == 4) {
                newDate.quarter = 1;
                newDate.year += 1;
            } else {
                newDate.quarter += 1;
            }

            this._model$.next(newDate);
        }
    }

    changeYear(year) {
        // console.log(year);
        year = parseInt(year);
        const newDate = {year: year, quarter: this.date ? this.date.quarter : null};
        this._model$.next(newDate);
    }

    changeQuarter(quarter) {
        // console.log(quarter);
        quarter = parseInt(quarter);
        const newDate = {year: this.date ? this.date.year : null, quarter: quarter};
        this._model$.next(newDate);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/ngbmomentpickers/custom-quarter-picker/custom-quarter-picker.component.ts